module.exports = __webpack_public_path__ + "img/vfe-90s.89004980.png";